<template>
    <div class="block block-rounded block-fx-shadow block-mode-loading-refresh">
      <div class="block-header block-header-default border-b mb-3">
          <h3 class="block-title">
            {{ $t('users.info') }}
          </h3>
          <div class="block-options">
              <button class="btn btn-sm btn-alt-primary" v-if="!editUser" @click.prevent="handleEditUser()">
                <i class="fa fa-edit"></i> {{ $t('buttons.edit') }}
              </button>
              <button class="btn btn-sm btn-alt-danger" v-if="editUser" @click.prevent="handleNotEditUser()">
                <i class="fa fa-times"></i> {{ $t('buttons.cancel') }}
              </button>
          </div>
      </div>
      <div class="block-content">
        <form @submit.stop.prevent="updateUser">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>{{ $t('users.login') }}</label>
                <input placeholder="Логин" class="form-control" name="login" type="text" v-model="adminUser.login" :readonly="!editUser" :class="{'is-invalid': errors.login }"/>
                <span v-if="errors.login" class="invalid-feedback">
                    <strong>{{ errors.login ? errors.login[0] : '' }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ $t('users.lastname') }}</label>
                <input placeholder="Фамилия" class="form-control" name="lastname" type="text" v-model="adminUser.lastname" :readonly="!editUser" :class="{'is-invalid': errors.lastname }"/>
                <span v-if="errors.lastname" class="invalid-feedback">
                    <strong>{{ errors.lastname ? errors.lastname[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ $t('users.firstname') }}</label>
                <input placeholder="Имя" class="form-control" name="firstname" type="text" v-model="adminUser.firstname" :readonly="!editUser" :class="{'is-invalid': errors.firstname }"/>
                <span v-if="errors.firstname" class="invalid-feedback">
                    <strong>{{ errors.firstname ? errors.firstname[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ $t('users.middlename') }}</label>
                <input placeholder="Отчества" class="form-control" name="middlename" type="text" v-model="adminUser.middlename" :readonly="!editUser" :class="{'is-invalid': errors.middlename }"/>
                <span v-if="errors.middlename" class="invalid-feedback">
                    <strong>{{ errors.middlename ? errors.middlename[0] : '' }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ $t('users.email') }}</label>
                <input placeholder="E-mail" class="form-control" name="email" type="text" v-model="adminUser.email" :readonly="!editUser" :class="{'is-invalid': errors.email }"/>
                <span v-if="errors.email" class="invalid-feedback">
                    <strong>{{ errors.email ? errors.email[0] : '' }}</strong>
                </span>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ $t('users.phone') }}</label>
                <input placeholder="Телефон" class="form-control" name="phone" type="text" v-model="adminUser.phone" :readonly="!editUser" :class="{'is-invalid': errors.phone }"/>
                <span v-if="errors.phone" class="invalid-feedback">
                    <strong>{{ errors.phone ? errors.phone[0] : '' }}</strong>
                </span>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="form-group">
                <label>{{ $t('users.pbx_extension_number') }}</label>
                <input
                  type="text" class="form-control"
                  v-model="adminUser.pbx_extension_number"
                  :readonly="!editUser">
                <span
                  v-if="errors.pbx_extension_number"
                  class="invalid-feedback"
                  :class="{'is-invalid': errors.pbx_extension_number }">
                    <strong>{{ errors.pbx_extension_number ? errors.pbx_extension_number[0] : '' }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>{{ $t('users.role') }}</label>
                <select class="form-control" v-model="adminUser.selectedRoles" multiple :readonly="!editUser">
                  <option v-for="role in adminListRoles" :value="role.id" :key="role.id">
                    {{ role.display_name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label>{{ $t('users.team') }}</label>
                <select class="form-control" v-model="adminUser.selectedTeams" multiple :readonly="!editUser">
                  <option v-for="team in adminListTeams" :value="team.id" :key="team.id">
                    {{ team.display_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row" v-if="editUser">
            <div class="col-lg-6">
                <div class="form-group">
                  <label>{{ $t('users.password') }}</label>
                  <input placeholder="Пароль" class="form-control" type="password" v-model="adminUser.password" :class="{'is-invalid': errors.password }"/>
                  <span v-if="errors.password" class="invalid-feedback">
                      <strong>{{ errors.password ? errors.password[0] : '' }}</strong>
                  </span>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                  <label>{{ $t('users.confirm_password') }}</label>
                  <input placeholder="Подтвердите пароль" class="form-control" type="password" v-model="adminUser.password_confirmation" :class="{'is-invalid': errors.password_confirmation }"/>
                  <span v-if="errors.password_confirmation" class="invalid-feedback">
                      <strong>{{ errors.password_confirmation ? errors.password_confirmation[0] : '' }}</strong>
                  </span>
                </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col">
              <div class="float-right">
                <button type="submit" class="btn btn-primary" v-if="editUser">
                  <i class="fa fa-save" v-if="!isProcessing"></i> <i class="fa fa-spinner fa-pulse" v-if="isProcessing"></i> {{ $t('buttons.save') }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      editUser: false,
      roles: [],
      teams: [],
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminUser',
      'adminListRoles',
      'adminListTeams',
    ]),
  },
  mounted() {
    this.GET_ADMIN_LIST_ROLES();
    this.GET_ADMIN_LIST_TEAMS();
  },
  methods: {
    ...mapActions([
      'UPDATE_ADMIN_USER',
      'GET_ADMIN_USER',
      'GET_ADMIN_LIST_ROLES',
      'GET_ADMIN_LIST_TEAMS',
    ]),
    handleEditUser() {
      this.editUser = true;
    },
    handleNotEditUser() {
      this.editUser = false;
    },
    updateUser() {
      this.isProcessing = true;
      this.UPDATE_ADMIN_USER(this.adminUser)
        .then(() => {
          this.GET_ADMIN_USER(this.$route.params.id);
          this.editUser = false;
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
